import React from "react";
import "./style.css";

const Footer = () => {
  return (
    <div className="footer-area">
      <div className="container">
        <div className="footer-content">
          <div className="content-sub">
            <h2>Xin chân thành cảm ơn 🫰</h2>
            <p className="footer-promise-text">
              Hẹn một ngày gần nhất chúng mình sẽ trở lại và cập nhật thật bùng nổ nhé! ✨
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
